import React, { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import {
    Form,
    Input,
    Button,
    DatePicker,
    Table,
    Spin,
    Pagination,
} from "antd";
import API, { CURRENT_TURNS, CURRENT_TURNS_EXCEL } from "../../network/api";
import moment from "moment";
import "moment-timezone";
import { TEXT_DEF } from "../../constant/text";
import {
  defaultDayRange,
  PICKER_DATE_FORMAT,
  pickerFromDisabled,
  pickerToDisabled,
  ymdFromPicker,
} from "../../constant/searchRange";

const TEXT = {
    totalTurns: 'Số lượt đã nhận',
    usedTurns: 'Số lượt đã chơi',
    remainTurns: 'Số lượt còn lại',
    time: 'Thời gian',
}

const PlayHistoryList = () => {
    const [form] = Form.useForm();
    const [, forceUpdate] = useState({});
    const dayRange = defaultDayRange();
    const [dateFrom, setDateFrom] = useState(dayRange.fromYmd);
    const [dateTo, setDateTo] = useState(dayRange.toYmd);
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const [summary, setSummary] = useState({
        totalTurns: 0,
        totalUsedTurns: 0,
        totalRemainTurns: 0
    });
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const locale = {
        emptyText: TEXT_DEF.text0035,
    };
    const [loading, setLoading] = useState(false);
    const usernameFilterLocal = localStorage.getItem("usernameFilter");
    const [dataFilter, setDataFilter] = useState(dayRange.query);

    useEffect(() => {
        forceUpdate({});
        const range = defaultDayRange();
        form.setFieldsValue({
            dateFrom: range.fromDayjs,
            dateTo: range.toDayjs,
        });
        if (usernameFilterLocal) {
            setDataFilter(`username=${usernameFilterLocal}&${range.query}`);
            form.setFieldValue("usernameFilter", usernameFilterLocal);
            localStorage.removeItem("usernameFilter");
        }
    }, [form, usernameFilterLocal]);

    const buildQuery = useCallback(() => {
        const qs = [`pageSize=10`, `page=${page}`];
        if (dataFilter && dataFilter.trim() !== "") qs.push(dataFilter);
        if (sortField && sortOrder) {
          const order = sortOrder === 'ascend' ? 'ASC' : 'DESC';
          qs.push(`sortField=${sortField}&sortOrder=${order}`);
        }
        return qs.join("&");
    }, [page, dataFilter, sortField, sortOrder]);

    const getListData = useCallback(async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${CURRENT_TURNS}?${buildQuery()}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data?.data || response[0].data.data;
                const summaryData = response[0].data.data?.summary || response[0].data.summary;
                
                if (summaryData) {
                    setSummary({
                        totalTurns: summaryData.totalTurns || 0,
                        totalUsedTurns: summaryData.totalUsedTurns || 0,
                        totalRemainTurns: summaryData.totalRemainTurns || 0
                    });
                }
                
                if (res && Array.isArray(res)) {
                    let dataCV = [];
                    res?.map((item) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            createdAt: item?.createdAt,
                            totalTurns: item?.totalTurns,
                            remainTurns: item?.remainTurns,
                            usedTurns: item?.usedTurns,
                        };
                        dataCV.push(user);
                        return dataCV;
                        // dataUserCV = dataUserCV.sort((a, b) => (moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()))
                    });

                    setDataList(dataCV);
                    setTotalRecord(response[0].data.data?.total || response[0].data.total || 0);
                    setLoading(false);
                } else {
                    setDataList([]);
                    setTotalRecord(0);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [buildQuery]);

    useEffect(() => {
        getListData();
    }, [getListData]);

    const onChangePage = (page) => {
        setPage(page);
    };

    const showTotal = (total) => `Tổng cộng ${total} dữ liệu`;

    const handleTableChange = (pagination, filters, sorter) => {
        // Ant Design Table có thể trả về sorter là object hoặc array
        const currentSorter = Array.isArray(sorter) ? sorter[0] : sorter;
        
        if (currentSorter) {
          // Ưu tiên lấy field từ sorter.field, sau đó columnKey, rồi mới đến column.dataIndex/column.key
          const fieldName = currentSorter.field || currentSorter.columnKey || (currentSorter.column && (currentSorter.column.dataIndex || currentSorter.column.key));
          const order = currentSorter.order;
          
          if (fieldName && order) {
            setSortField(fieldName);
            setSortOrder(order);
            setPage(1); // Reset về trang đầu khi sort
          } else {
            // Clear sort khi click lần nữa (order là null/undefined)
            setSortField(null);
            setSortOrder(null);
          }
        } else {
          setSortField(null);
          setSortOrder(null);
        }
    };

      const onSearch = () => {
        let params = "";
        const usernameVal = form.getFieldValue("usernameFilter");
        const statusVal = form.getFieldValue("userStatus");
    
        if (usernameVal)
          params += `username=${String(usernameVal).trim().toLowerCase()}`;
        if (statusVal)
          params += params !== "" ? `&status=${statusVal}` : `status=${statusVal}`;
        if (dateFrom)
          params += params !== "" ? `&fromDate=${dateFrom}` : `fromDate=${dateFrom}`;
        if (dateTo) {
          params += params !== "" ? `&toDate=${dateTo}` : `toDate=${dateTo}`;
          if (!dateFrom)
            params += `&fromDate=${dayRange.fromYmd}`;
        }
    
        setPage(1);
        setDataFilter(params !== "" ? params : null);
      };

    const dataColums = [
        {
            title: "STT",
            align: "center",
            key: "order",
            render: (text, record, index) => (
                <span>{(page - 1) * 10 + (index + 1)}</span>
            ),
        },
        {
            title: TEXT_DEF.text0002,
            dataIndex: "username",
            key: "username",
        },
        {
            title: 'Thời gian',
            key: "createdAt",
            render: (record) =>
                moment(record?.createdAt).utcOffset(7).format("DD-MM-YYYY HH:mm:ss"),
        },
        {
            title: TEXT.totalTurns,
            key: "totalTurns",
            dataIndex: "totalTurns",
            sorter: true,
            sortDirections: ["ascend", "descend"],
        },
        {
            title: TEXT.usedTurns,
            key: "usedTurns",
            dataIndex: "usedTurns",
            sorter: true,
            sortDirections: ["ascend", "descend"],
        },
        {
            title: TEXT.remainTurns,
            key: "remainTurns",
            dataIndex: "remainTurns",
        }
    ];

    const onChangeDate = (value, type) => {
        if (value) {
            if (type === "from") setDateFrom(ymdFromPicker(value, false));
            else setDateTo(ymdFromPicker(value, true));
        } else if (type === "from") {
            setDateFrom(null);
        } else {
            setDateTo(null);
        }
    };

    const handleDownloadExcel = async () => {
        await API.post(
            `${CURRENT_TURNS_EXCEL}?${buildQuery()}`,
            {},
            { responseType: 'blob' })
                .then(async (response) => {
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;

                    // Optional: lấy tên file từ response header nếu có
                    const disposition = response.headers.get('Content-Disposition');
                    let fileName = 'lich_su_luot_choi.xlsx';
                    if (disposition && disposition.includes('filename=')) {
                        fileName = disposition.split('filename=')[1].replace(/"/g, '');
                    }

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    setLoading(false);
                });
    };

    const renderHistory = () => {
        return (
            <>
                <div className="col-12">
                    <Form
                        form={form}
                        layout="inline"
                        autoComplete="off"
                        onFinish={() => onSearch()}
                    >
                        <div
                            className="col-12"
                            style={{ marginBottom: 15, display: "flex" }}
                        >
                            <div className="col-5">
                                <Form.Item name="usernameFilter" label={TEXT_DEF.text0002}>
                                    <Input style={{ width: "100%" }} />
                                </Form.Item>
                            </div>
                        </div>

                        <div
                            className="col-12"
                            style={{ marginBottom: 15, display: "flex" }}
                        >
                            <div className="col-5">
                                <Form.Item name="dateFrom" label={TEXT_DEF.text0032}>
                                    <DatePicker
                                        placeholder=""
                                        onChange={(value) => onChangeDate(value, "from")}
                                        format={PICKER_DATE_FORMAT}
                                        style={{ width: "100%" }}
                                        disabledDate={pickerFromDisabled(dateTo)}
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-5">
                                <Form.Item name="dateTo" label={TEXT_DEF.text0033}>
                                    <DatePicker
                                        placeholder=""
                                        onChange={(value) => onChangeDate(value, "to")}
                                        format={PICKER_DATE_FORMAT}
                                        style={{ width: "100%" }}
                                        disabledDate={pickerToDisabled(dateFrom)}
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        <div className="payment-search">
                            <Button htmlType="submit" type="primary">
                                {TEXT_DEF.text0031}
                            </Button>
                            <Button
                                style={{ marginLeft: 20 }}
                                onClick={handleDownloadExcel}
                                htmlType="button"
                                type="primary"
                            >
                                {TEXT_DEF.text0050}
                            </Button>
                        </div>
                    </Form>
                </div>

                {/* 3 tổng số — NGAY SAU Ô SEARCH & TRƯỚC BẢNG, lấy từ summary API */}
                <div
                    className="col-12"
                    style={{
                    display: "flex",
                    gap: 40,
                    margin: "12px 0 8px",
                    fontWeight: 600,
                    fontSize: 15,
                    flexWrap: "wrap",
                    }}
                >
                    <div>Tổng số lượt đã nhận: {summary.totalTurns}</div>
                    <div>Tổng số lượt đã chơi: {summary.totalUsedTurns}</div>
                    <div>Tổng số lượt còn lại: {summary.totalRemainTurns}</div>
                </div>

                <Spin spinning={loading} delay={500} size="large">
                    <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                        <Table
                            key="conversionList"
                            locale={locale}
                            columns={dataColums}
                            dataSource={dataList}
                            pagination={false}
                            bordered
                            style={{ width: "100%" }}
                            onChange={handleTableChange}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            marginTop: 15,
                            justifyContent: "flex-end",
                        }}
                    >
                        <Pagination
                            current={page}
                            total={totalRecord}
                            onChange={onChangePage}
                            defaultPageSize={10}
                            showSizeChanger={false}
                            showTotal={showTotal}
                        />
                    </div>
                </Spin>
            </>
        );
    };

    return (
        <div className="col-12">
            {renderHistory()}
        </div>
    );
};

export default PlayHistoryList;
